/**
 * Stores service
 */
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { selectIsIframeMode } from '@rpt-ngrx/selectors/session.selector';

import { PortalHttpClient } from '../http-client/portal-http-client.service';

// Mock data
// import { throwError as observableThrowError, Observable, of } from 'rxjs';
// import { delay, map, catchError } from 'rxjs/operators';
// import { DUTCH_BROS_COMPANY } from '../../mock-data/base-companies.mock';

@Injectable()
export class OpraDataService {
    private url = '/me';
    constructor(
        private http: PortalHttpClient,
        private store: Store,
    ) {}

    // NOTE: This method is not used anywhere in production code (only in unit tests).
    // The OPRA API /me/sites endpoint uses OData syntax ($top, $skip, $select, $filter),
    // not plain `limit`/`skip` params — so these parameters would have no effect even if the method were called.
    public fetchStores(query): Observable<any> {
        const params: Record<string, string> = {};
        if (query) {
            if ('limit' in query) {
                params['limit'] = query.limit;
            }
            if ('skip' in query) {
                params['skip'] = query.skip;
            }
        }

        return this.http
            .get(`${this.url}/sites`, { params })
            .pipe(catchError((error) => observableThrowError(error.errors)));
    }

    public fetchStoresByCompany(companyId: string): Observable<any> {
        return this.http
            .get(`/companies/${companyId}/sites`)
            .pipe(catchError((error) => observableThrowError(error.errors)));
    }

    public getUserInfo(): Observable<any> {
        return this.http.get(`${this.url}`).pipe(catchError((error) => observableThrowError(error.errors)));
    }

    public getUserCompanyRoles(companyId: string, userId: string): Observable<any> {
        return this.http
            .get(`/v1/companies/${companyId}/people/${userId}`)
            .pipe(catchError((error) => observableThrowError(error.errors)));
    }

    public fetchCompaniesWithSites(): Observable<any> {
        // TODO: work with fake data on the dev environment
        // Mock data
        // const response = DUTCH_BROS_COMPANY;
        // return of(response).pipe(
        //     delay(3000),
        //     catchError(error => observableThrowError(error.errors)),
        //     map(responseData => {
        //         return responseData;
        //     })
        // );
        return this.http
            .get(`${this.url}/companies/sites`, { params: { $select: 'name,id,timezone' } })
            .pipe(catchError((error) => observableThrowError(error.errors)));
    }

    /**
     * Method for updating company roles
     * @param {Object} data - data object with app_code, name, roles
     *    {
     *       app_code: "string",
     *       name: "string",
     *       roles: [":role1_id", ":role2_id"]
     *     }
     * @returns {Observable<any>}
     */
    public updateCompanyPermission(companyId: string, data): Observable<any> {
        return this.http
            .post(`/companies/${companyId}/permissions`, data)
            .pipe(catchError((error) => observableThrowError(error.errors)));
    }

    public isIframe(): Observable<any> {
        return this.store.select(selectIsIframeMode);
    }

    public getEnvironmentInfo(): Observable<any> {
        return this.http.get(`/info`).pipe(catchError((error) => observableThrowError(error.errors)));
    }
}
